const routeFinance = {
  path: 'finance',
  name: 'finance',
  component: () =>
    import(/* webpackChunkName: "finance" */ '@/views/Finance/Placeholder.vue')
}

export { routeFinance }
